import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminSectionContentCards = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.SECTION_CONTENT_CARDS.GET_ALL, { params });
    return response.data;
};

export const getAdminSectionContentCardById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.SECTION_CONTENT_CARDS.GET_BY_ID(id));
    return response.data;
};

export const createSectionContentCard = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.SECTION_CONTENT_CARDS.CREATE, data);
    return response.data;
};

export const updateSectionContentCard = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.SECTION_CONTENT_CARDS.UPDATE(id), data);
    return response.data;
};

export const deleteSectionContentCard = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.SECTION_CONTENT_CARDS.DELETE(id));
    return response.data;
};
